import { Box } from "@mui/material";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import { links } from "utilities/links";
import { CollectionForm } from "./CollectionForm";
import { useStyles } from "./CollectionForm.styles";

export const AddCollection = () => {
  const { message } = useMessage();
  const classes = useStyles();

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "collections" }),
      path: links.collectionsList,
    },
  };

  return (
    <>
      <TopHeader
        title={message({ id: "newCollection" })}
        clearLink={links.collectionsList}
        breadcrumbs={breadcrumbs}
      />
      <Box className={classes.collectionFormContent}>
        <CollectionForm />
      </Box>
    </>
  );
};
